const hexToRGBAndHue = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  let hue;
  let rgb;

  if (result) {
    let r = parseInt(result[1], 16);
    let g = parseInt(result[2], 16);
    let b = parseInt(result[3], 16);

    rgb = `${r}, ${g}, ${b}`;

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-sequences
    (r /= 255), (g /= 255), (b /= 255);
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h;
    let s;
    const l = (max + min) / 2;
    if (max === min) {
      // eslint-disable-next-line no-multi-assign
      h = s = 0; // achromatic
    } else {
      const d = max - min;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
        default:
          break;
      }

      if (h) {
        h /= 6;
      }
    }

    if (h) {
      h = Math.round(h * 360);
    }

    hue = h;
  }

  return { hue, rgb };
};

export default hexToRGBAndHue;
